import styled from 'styled-components';
import { m } from 'framer-motion';
import {
  getTypographyVariant,
} from '@glowforge/gf-styled/src/components/typography';




const PillButtonWrapper = styled('div')`
  padding: 0 20px 50px 20px;
  grid-column: full-start / full-end;
  display: flex;
  flex-direction: row;
  justify-content: center;
  white-space: nowrap; /* Don't wrap buttons. */
  padding-bottom: 34px;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 20px;
  @media (max-width: 991px) {
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const PillButton = styled('button')`
  max-width: 100px;
  min-width: 100px;
  min-height: 34px !important;
  font-size: 16px !important;
  padding: 0;
  color: black !important;
  font-size: inherit;
  letter-spacing: -0.8px !important;
  line-height: 6.3px;
  flex: 1;
  border: 2px solid rgb(229, 229, 229,1);
  border-radius: 160px;
  background: ${(props) =>
    // no idea where this color came from or why it isn't in design system.
    props.active ? 'rgba(39,184,206,1)' : 'rgb(229, 229, 229,1)'};
  color: ${(props) =>
    props.active ? '#fff !important' : props.theme.colors.slate.base};


  transition: background 0.2s ease-in-out;
  ${getTypographyVariant('paragraph')}
  --font-family: 'Space Grotesk';
  --font-weight: 700;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.colors.magic.buttonBase};
    background: ${(props) => props.theme.colors.magic.buttonBase};
    color: #fff !important;
  }
  @media (max-width: 991px){
    background: ${(props) =>
    // no idea where this color came from or why it isn't in design system.
    props.active ? 'rgba(39,184,206,1)' : 'transparent'};
`;

const ImageFlexContainer = styled('div')`
  display: flex;
  position: relative;
  max-width: 100%;
`;

const LeftWrapper = styled('div')`
    position: absolute;
    width: 12%;
    height: 100%;
    transition: all 1s ease;
    opacity: ${(props) => (props.isSectionVisible ? '1' : '0')};
    transition-delay: 0.1s;
    transform: translateX(${(props) => (props.isSectionVisible ? '0' : '-100%')});
  @media (max-width: 991px) {
  display: none;
`;

const RightContainer = styled('div')`
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    @media (max-width: 991px) {
      display: none;
    }
`

const RightWrapper = styled('div')`
    position: absolute;
    right:0;
    width: 10%;
    height: 100%;
    transition: all 1s ease;
    opacity: ${(props) => (props.isSectionVisible ? '1' : '0')};
    transform: translateX(${(props) => (props.isSectionVisible ? 0 : '100%')});
    transition-delay: 0.3s;
    @media (max-width: 991px) {
  display: none;
}
`;


const MultiImageWrapper = styled('div')`
margin-top: 50px !important;
transform: translateY(${(props) => (props.isSectionVisible ? 0 : "15%")});
opacity: ${(props) => (props.isSectionVisible ? '1' : '0')};
transition: all 1s ease;
margin: 0 auto;
width: 35%;
grid-column: main-start / main-end;
display: grid;
grid-template-rows: 1fr 1fr; 
grid-template-columns: 1fr 1fr; 
grid-gap: 10px;
grid-auto-columns: 1fr;
grid-auto-flow: column;
grid-template-areas:
  'img0 img1'
  'img2 img3'
;
padding-bottom: 42px;
justify-content: center;

img,
picture {
  ${(props) => (props.isBuilder ? 'display: block;' : '')}
  ${(props) => (props.isBuilder ? 'width: 100%;' : '')}
  ${(props) => (props.isBuilder ? 'height: 100%;' : '')}
}

@media ${(props) => props.theme.queries.desktopAndUp} {
  ${(props) =>
    props.isBuilder
      ? `grid-column: full-start / full-end;`
      : 'grid-column: main-start / main-end;'}

  ${(props) =>
    props.isBuilder ? 'padding-left: 20px; padding-right: 20px;' : null}
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    'img0 img1'
    'img2 img3';
  justify-content: unset;
  justify-items: center;
}
@media (max-width: 991px) {
  width: 100%;
  padding: 0 20px;
  grid-gap: 10px;
  margin-top: 0 !important;
}
`;

const SidePicture = styled('div')`
width: 100%;
height: 100%;
`;

const MultiPicture = styled(m.div)`
grid-area: ${(props) => `img${props.index}`};
width: 100%;
aspect-ratio: 1/1;
display: inline-block;
opacity: 0;
border-radius: 5px;
overflow: hidden;

@media ${(props) => props.theme.queries.desktopAndUp} {
  display: block;
}
`;

const ButtonWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: center;
`;

const SwipeText = styled('div')`
  display: none;
  @media (max-width: 991px) {
    display: block;
    margin: 0 auto 20px auto;
    font-size: 14px;
    font-family: 'Space Grotesk';
    font-family: 'Space Grotesk';
  }
`;

export {
  PillButtonWrapper,
  PillButton,
  ButtonWrapper,
  ImageFlexContainer,
  MultiImageWrapper,
  MultiPicture,
  SwipeText,
  LeftWrapper,
  RightWrapper,
  SidePicture,
  RightContainer
};
